<template>
  <div class="wrapper-container swiper-container">
    <div class="swiper-wrapper">
      <div v-for="(item, index) in picArr" :key="index" class="swiper-slide">
        <img :src="/^http/.test(item.img) ? item.img : require(`../assets${item.img}`)" alt="icon" class="img">
        <p v-show="item.des" class="des">{{ item.des }}</p>
      </div>
    </div>
    <div class="swiper-pagination"/>
    <div class="swiper-button-prev"/>
    <div class="swiper-button-next"/>
  </div>
</template>

<script>
import 'swiper/css/swiper.min.css'
import Swiper from 'swiper'

export default {
  name: 'LoopPic',
  props: {
    picArr: {
      type: Array,
      required: true,
      default: function () {
        return []
      },
    },
    indicatorPosition: {
      type: String,
      default: 'outside',
    },
    interval: {
      type: Number,
      default: 5000,
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.initLoopPic()
    })
  },
  methods: {
    initLoopPic () {
      new Swiper('.swiper-container', {
        loop: true,
        autoplay: {
          delay: this.interval,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  .wrapper-container {
    height: 100%;
    width: 100%;
    .swiper-slide {
      position: relative;
      border-radius: 10px;
      overflow: hidden;
      .img {
        object-fit: contain;
        height: 100%;
        width: 100%;
      }
      .des {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0.1rem 0.2rem;
        font-size: 0.20rem;
        line-height: 1.2;
        color: #eee;
        letter-spacing: 0.02rem;
        background-color: rgba(31, 31, 212, 0.5);
      }
    }
    .swiper-button-prev, .swiper-button-next {
      outline: none;
    }
    .swiper-button-prev:after,  .swiper-button-next:after{
      color:#47a3db;
    }
  }
</style>
